import React from 'react';

const colorStyles = {
  blue: {
    bg: 'from-sky-50 to-sky-100',
    iconBg: 'bg-sky-100 text-sky-600',
    dot: 'bg-sky-400',
  },
  purple: {
    bg: 'from-violet-50 to-violet-100',
    iconBg: 'bg-violet-100 text-violet-600',
    dot: 'bg-violet-400',
  },
  green: {
    bg: 'from-emerald-50 to-emerald-100',
    iconBg: 'bg-emerald-100 text-emerald-600',
    dot: 'bg-emerald-400',
  },
  yellow: {
    bg: 'from-amber-50 to-amber-100',
    iconBg: 'bg-amber-100 text-amber-600',
    dot: 'bg-amber-400',
  },
  red: {
    bg: 'from-rose-50 to-rose-100',
    iconBg: 'bg-rose-100 text-rose-600',
    dot: 'bg-rose-400',
  },
};

const StatsCard = ({
  title,
  value,
  trend,
  color = 'blue',
  icon,
  isRTL = false,
}) => {
  const styles = colorStyles[color] || colorStyles.blue;

  const isPositive = trend && trend.toString().trim().startsWith('+');

  return (
    <div
      className={`relative overflow-hidden rounded-2xl border border-slate-100 bg-gradient-to-br ${styles.bg} p-4 shadow-sm hover:shadow-md transition-shadow`}
    >
      {/* Decorative dot */}
      <div className="pointer-events-none absolute -right-6 -top-6 h-16 w-16 rounded-full bg-white/40 blur-xl" />

      <div
        className={`flex items-center justify-between ${
          ''
        }`}
      >
        <div className="space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wide text-slate-500">
            {title}
          </p>
          <div className="flex items-baseline gap-2">
            <span className="text-2xl md:text-3xl font-extrabold text-slate-900">
              {value}
            </span>
            {trend && (
              <span
                className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                  isPositive
                    ? 'bg-emerald-100 text-emerald-700'
                    : 'bg-rose-100 text-rose-700'
                }`}
              >
                <span
                  className={`mr-1 inline-block h-1.5 w-1.5 rounded-full ${
                    isPositive ? 'bg-emerald-500' : 'bg-rose-500'
                  }`}
                />
                {trend}
              </span>
            )}
          </div>
        </div>

        {icon && (
          <div
            className={`flex h-10 w-10 items-center justify-center rounded-full text-base ${styles.iconBg}`}
          >
            {icon}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatsCard;


